import React, { useState, useEffect, useMemo } from 'react';
import {
  Space,
  Button,
  DatePicker,
  Select,
  Tooltip,
  Modal,
  Spin,
  message,
  Badge,
  Tag,
  Input
} from 'antd';
import {
  LeftOutlined,
  RightOutlined,
  ReloadOutlined,
  SearchOutlined,
  CalendarOutlined,
  HomeOutlined,
  UserOutlined,
  TeamOutlined,
  CloseOutlined,
  CheckOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { BASE_URL } from '../utils/constants';
// import { useTranslation } from 'react-i18next';
import PlaningHabitaciones from './PlaningHabitaciones';

dayjs.extend(isBetween);

const { RangePicker } = DatePicker;
const { Option } = Select;

const PlaningHabitaciones2 = () => {
//   const { t } = useTranslation();
  
  // Estados
  const [loading, setLoading] = useState(false);
  const [fechas, setFechas] = useState({
    desde: dayjs().startOf('month'),
    hasta: dayjs().endOf('month')
  });
  const [habitaciones, setHabitaciones] = useState([]);
  const [fechasList, setFechasList] = useState([]);
  const [tiposHabitacion, setTiposHabitacion] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);
  const [loadingReserva, setLoadingReserva] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedTipo, setSelectedTipo] = useState('');

  // Calcular dimensiones
  const dayWidth = 80;
  const sidebarWidth = 220;
  const rowHeight = 70;

  // Colores por tipo de reserva
  const getColorByType = (tipo) => {
    const colores = {
      'L': { bg: '#e6f7ff', border: '#91d5ff', text: '#0050b3' },
      'B': { bg: '#fff1f0', border: '#ffa39e', text: '#a8071a' },
      'O': { bg: '#f6ffed', border: '#b7eb8f', text: '#237804' },
      'R': { bg: '#fff7e6', border: '#ffd591', text: '#ad4e00' },
      'D': { bg: '#f9f0ff', border: '#d3adf7', text: '#391085' },
    };
    return colores[tipo] || { bg: '#fafafa', border: '#f0f0f0', text: '#000000' };
  };

  // Cargar datos iniciales
  useEffect(() => {
    cargarTiposHabitacion();
    cargarPlaning();
  }, []);

  useEffect(() => {
    cargarPlaning();
  }, [fechas.desde, fechas.hasta, selectedTipo]);

  const cargarTiposHabitacion = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/planing/tipos-habitacion`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTiposHabitacion(response.data.data || []);
    } catch (error) {
      console.error('Error cargando tipos:', error);
    }
  };

  const cargarPlaning = async () => {
    if (!fechas.desde || !fechas.hasta) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      const params = {
        fechaDesde: fechas.desde.format('YYYY-MM-DD'),
        fechaHasta: fechas.hasta.format('YYYY-MM-DD'),
        tipoHabitacion: selectedTipo
      };
      
      const response = await axios.get(`${BASE_URL}/api/planing`, {
        headers: { Authorization: `Bearer ${token}` },
        params: params
      });

      if (response.data.success) {
        const data = response.data.data;
        setHabitaciones(data.habitaciones || []);
        setFechasList(data.fechas || []);
      }
    } catch (error) {
      console.error('Error cargando planing:', error);
      message.error(('Error al cargar el planing'));
    } finally {
      setLoading(false);
    }
  };

  const handleVerReserva = async (numReserva) => {
    if (!numReserva || numReserva === 0) return;
    
    setLoadingReserva(true);
    setModalVisible(true);
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/planing/reserva/${numReserva}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        setReservaSeleccionada(response.data.data);
      }
    } catch (error) {
      console.error('Error cargando reserva:', error);
      message.error(('Error al cargar los detalles'));
      setModalVisible(false);
    } finally {
      setLoadingReserva(false);
    }
  };

  const handleNavegarSemana = (direccion) => {
    const nuevaFechaDesde = direccion === 'adelante' 
      ? fechas.desde.add(7, 'day')
      : fechas.desde.subtract(7, 'day');
    
    const nuevaFechaHasta = direccion === 'adelante'
      ? fechas.hasta.add(7, 'day')
      : fechas.hasta.subtract(7, 'day');
    
    setFechas({
      desde: nuevaFechaDesde,
      hasta: nuevaFechaHasta
    });
  };

  const getReservaForDate = (habitacion, fecha) => {
    const fechaObj = dayjs(fecha).startOf('day');
    return habitacion.Reservas?.find(res => {
      const desde = dayjs(res.Desde).startOf('day');
      const hasta = dayjs(res.Hasta).startOf('day');
      return fechaObj.isBetween(desde, hasta, 'day', '[)');
    });
  };

  const habitacionesFiltradas = useMemo(() => {
    if (!searchText) return habitaciones;
    
    return habitaciones.filter(hab => {
      const busqueda = searchText.toLowerCase();
      const tieneReservaCoincidente = hab.Reservas?.some(res => 
        res.Nombre?.toLowerCase().includes(busqueda) ||
        res.NumReserva?.toString().includes(busqueda)
      );
      return hab.NumHabitacion?.toString().includes(busqueda) || tieneReservaCoincidente;
    });
  }, [habitaciones, searchText]);

  if (loading && habitaciones.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Spin size="large" tip={('Cargando planing...')} />
      </div>
    );
  }

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#fff' }}>
      {/* Barra de herramientas */}
      <div style={{ 
        padding: '16px',
        background: '#f8f9fa',
        borderBottom: '1px solid #e9ecef',
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <Space size="middle">
          <RangePicker
            value={[fechas.desde, fechas.hasta]}
            onChange={(dates) => {
              if (dates && dates.length === 2) {
                setFechas({ desde: dates[0], hasta: dates[1] });
              }
            }}
            format="DD/MM/YYYY"
            allowClear={false}
          />
          
          <Button.Group>
            <Button 
              icon={<LeftOutlined />} 
              onClick={() => handleNavegarSemana('atras')}
            />
            <Button 
              icon={<RightOutlined />} 
              onClick={() => handleNavegarSemana('adelante')}
            />
          </Button.Group>
          
          <Button 
            icon={<ReloadOutlined />} 
            onClick={cargarPlaning}
          />
        </Space>

        <Input
          placeholder={('Buscar habitación o cliente...')}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          prefix={<SearchOutlined />}
          allowClear
          style={{ width: 250 }}
        />

        <Select
          placeholder={('Tipo habitación')}
          value={selectedTipo || undefined}
          onChange={setSelectedTipo}
          allowClear
          style={{ width: 180 }}
        >
          {tiposHabitacion.map(tipo => (
            <Option key={tipo} value={tipo}>{tipo}</Option>
          ))}
        </Select>

        <Badge 
          count={habitacionesFiltradas.length} 
          style={{ backgroundColor: '#1890ff' }} 
          overflowCount={999}
        />
      </div>

      {/* Contenedor principal con scroll */}
      <div style={{ 
        flex: 1,
        overflow: 'auto',
        position: 'relative'
      }}>
        {/* Cabecera con fechas */}
        <div style={{ 
          display: 'flex',
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: '#fff',
          borderBottom: '2px solid #dee2e6',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          {/* Columna fija de habitaciones */}
          <div style={{ 
            width: sidebarWidth,
            padding: '12px 16px',
            fontWeight: 600,
            background: '#f1f3f5',
            borderRight: '2px solid #dee2e6',
            position: 'sticky',
            left: 0,
            zIndex: 11,
            fontSize: '14px',
            color: '#495057'
          }}>
            {('Habitaciones')}
          </div>

          {/* Días */}
          <div style={{ display: 'flex' }}>
            {fechasList.map((fecha, index) => {
              const fechaObj = dayjs(fecha);
              const esHoy = fechaObj.isSame(dayjs(), 'day');
              const esFinDeSemana = fechaObj.day() === 0 || fechaObj.day() === 6;
              
              return (
                <div
                  key={index}
                  style={{
                    width: dayWidth,
                    padding: '8px 4px',
                    textAlign: 'center',
                    background: esHoy ? '#e7f5ff' : esFinDeSemana ? '#f8f9fa' : '#fff',
                    borderRight: '1px solid #e9ecef',
                    fontWeight: esHoy ? 600 : 400
                  }}
                >
                  <div style={{ fontSize: '13px', color: '#868e96', textTransform: 'uppercase' }}>
                    {fechaObj.format('ddd')}
                  </div>
                  <div style={{ fontSize: '18px', fontWeight: 600, color: esHoy ? '#228be6' : '#495057' }}>
                    {fechaObj.format('DD')}
                  </div>
                  <div style={{ fontSize: '11px', color: '#adb5bd' }}>
                    {fechaObj.format('MMM')}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Filas de habitaciones */}
        {habitacionesFiltradas.length === 0 ? (
          <div style={{ 
            padding: '48px', 
            textAlign: 'center', 
            color: '#868e96',
            fontSize: '16px'
          }}>
            {('No hay habitaciones para mostrar')}
          </div>
        ) : (
          habitacionesFiltradas.map((habitacion, index) => (
            <div
              key={habitacion.NumHabitacion}
              style={{
                display: 'flex',
                borderBottom: '1px solid #e9ecef',
                background: index % 2 === 0 ? '#fff' : '#f8f9fa',
                transition: 'background 0.2s'
              }}
            >
              {/* Datos de la habitación */}
              <div style={{
                width: sidebarWidth,
                padding: '12px 16px',
                background: 'inherit',
                borderRight: '1px solid #e9ecef',
                position: 'sticky',
                left: 0,
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Tag color="blue" style={{ fontSize: '14px', padding: '4px 8px', margin: 0 }}>
                    {habitacion.NumHabitacion}
                  </Tag>
                  <Tag color="purple" style={{ margin: 0 }}>
                    {habitacion.HabitacionVenta2 || 'N/A'}
                  </Tag>
                </div>
                <div style={{ fontSize: '12px', color: '#868e96' }}>
                  {habitacion.TipoHabitacion}
                </div>
                <div style={{ fontSize: '11px', color: '#adb5bd' }}>
                  Piso {habitacion.Piso || 0}
                </div>
              </div>

              {/* Celdas de días */}
              <div style={{ display: 'flex' }}>
                {fechasList.map((fecha, idxFecha) => {
                  const reserva = getReservaForDate(habitacion, fecha);
                  const colors = reserva ? getColorByType(reserva.Tipo) : null;
                  
                  return (
                    <Tooltip
                      key={idxFecha}
                      title={reserva ? (
                        <div style={{ padding: '8px', maxWidth: '250px' }}>
                          <div style={{ fontWeight: 600, marginBottom: '8px' }}>{reserva.Nombre}</div>
                          <div style={{ fontSize: '12px' }}>
                            <div>📋 Reserva: {reserva.NumReserva}</div>
                            <div>📅 Entrada: {dayjs(reserva.Desde).format('DD/MM/YYYY')}</div>
                            <div>📅 Salida: {dayjs(reserva.Hasta).format('DD/MM/YYYY')}</div>
                            <div>👥 Pax: {reserva.Pax}</div>
                            <div>🏢 Agencia: {reserva.Agencia || 'Directa'}</div>
                            <div style={{ marginTop: '4px' }}>
                              Estado: {reserva.Confirmada ? 
                                <span style={{ color: '#40c057' }}>✓ Confirmada</span> : 
                                <span style={{ color: '#fa5252' }}>✗ Pendiente</span>
                              }
                            </div>
                          </div>
                        </div>
                      ) : 'Libre'}
                      placement="top"
                    >
                      <div
                        onClick={() => reserva && handleVerReserva(reserva.NumReserva)}
                        style={{
                          width: dayWidth,
                          height: rowHeight,
                          padding: '6px',
                          background: reserva ? colors.bg : 'transparent',
                          borderRight: '1px solid #e9ecef',
                          cursor: reserva ? 'pointer' : 'default',
                          overflow: 'hidden',
                          position: 'relative',
                          transition: 'all 0.2s',
                          ...(reserva && {
                            borderLeft: `3px solid ${colors.border}`,
                          })
                        }}
                      >
                        {reserva && (
                          <div style={{ 
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}>
                            <div style={{ 
                              fontWeight: 600,
                              fontSize: '12px',
                              color: colors.text,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              marginBottom: '2px'
                            }}>
                              {reserva.Nombre}
                            </div>
                            <div style={{ 
                              display: 'flex',
                              justifyContent: 'space-between',
                              fontSize: '10px',
                              color: '#868e96'
                            }}>
                              <span>#{reserva.NumReserva}</span>
                              <span>{reserva.Pax} 👤</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </Tooltip>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal de detalles de reserva */}
      <Modal
        title={
          <Space>
            <CalendarOutlined style={{ color: '#228be6' }} />
            <span style={{ fontWeight: 600 }}>Reserva #{reservaSeleccionada?.NumReserva}</span>
            {reservaSeleccionada?.Confirmada ? (
              <Tag color="success">Confirmada</Tag>
            ) : (
              <Tag color="warning">Pendiente</Tag>
            )}
          </Space>
        }
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={500}
      >
        {loadingReserva ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Spin />
          </div>
        ) : reservaSeleccionada && (
          <div style={{ padding: '12px 0' }}>
            {/* Datos principales */}
            <div style={{ 
              background: '#f8f9fa', 
              padding: '16px', 
              borderRadius: '8px',
              marginBottom: '16px'
            }}>
              <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                <div>
                  <UserOutlined style={{ marginRight: '8px', color: '#228be6' }} />
                  <strong>{reservaSeleccionada.Nombre}</strong>
                </div>
                <div>
                  <TeamOutlined style={{ marginRight: '8px', color: '#228be6' }} />
                  {reservaSeleccionada.Pax || 1} Pax
                </div>
                <div>
                  <HomeOutlined style={{ marginRight: '8px', color: '#228be6' }} />
                  {reservaSeleccionada.Habitaciones?.length || 1} Hab
                </div>
              </div>
            </div>

            {/* Fechas */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr 1fr', 
              gap: '16px', 
              marginBottom: '16px',
              padding: '0 8px'
            }}>
              <div>
                <div style={{ color: '#868e96', fontSize: '12px', marginBottom: '4px' }}>Entrada</div>
                <div style={{ fontSize: '16px', fontWeight: 600 }}>
                  {dayjs(reservaSeleccionada.FechaEntrada).format('DD/MM/YYYY')}
                </div>
              </div>
              <div>
                <div style={{ color: '#868e96', fontSize: '12px', marginBottom: '4px' }}>Salida</div>
                <div style={{ fontSize: '16px', fontWeight: 600 }}>
                  {dayjs(reservaSeleccionada.FechaSalida).format('DD/MM/YYYY')}
                </div>
              </div>
            </div>

            {/* Agencia */}
            <div style={{ marginBottom: '16px', padding: '0 8px' }}>
              <div style={{ color: '#868e96', fontSize: '12px', marginBottom: '4px' }}>Agencia</div>
              <div>{reservaSeleccionada.Agencia || 'Directa'}</div>
            </div>

            {/* Habitaciones */}
            {reservaSeleccionada.Habitaciones?.length > 0 && (
              <div style={{ padding: '0 8px' }}>
                <div style={{ color: '#868e96', fontSize: '12px', marginBottom: '8px' }}>
                  Habitaciones asignadas
                </div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {reservaSeleccionada.Habitaciones.map((hab, idx) => (
                    <Tag key={idx} color="blue" style={{ padding: '4px 8px' }}>
                      {hab.NumHabitacio} - {hab.TipoHabitacion}
                    </Tag>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PlaningHabitaciones2;